// extracted by mini-css-extract-plugin
var _1 = "SelectDropdownListHeader-moduleSelectDropdownListHeader__OFFXZ";
var _2 = "SelectDropdownListHeader-moduledivider__WSrhh Divider-moduleDivider__dL3Vg";
export { _1 as "SelectDropdownListHeader", _2 as "divider" }
